// extracted by mini-css-extract-plugin
export default {"header_large":"PopupHeaderComponent_header_large__qxvba","header":"PopupHeaderComponent_header__ejgUF"};